import React from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const Meta = ({title = null, description = null, image = null}) => {
  const location = useLocation();
  return (
    <Helmet>
      <title>{title ? title + " | Autofficina ACS" : "Autofficina ACS"}</title>
      <meta property="og:title" content={title ? title + " | Autofficina ACS" : "Autofficina ACS"} />
      {description ? 
        <meta name="description" content={description} />
      : 
        <meta name="description" content={"Riparazioni meccaniche auto e furgoni dal 1999 a Mantova"} />
      }
      {description ? 
        <meta property="og:description" content={description} />
      : 
        <meta property="og:description" content={"Riparazioni meccaniche auto e furgoni dal 1999 a Mantova"} />
      }
      {image ? 
        <meta property="og:image" content={image} />
      : 
        <meta property="og:image" content="https://www.autofficinaacs.it/photos/header.jpg" />
      }
      <meta property="og:type" content="website" />
      <meta property="og:url" content={"https://www.autofficinaacs.it"+location.pathname} />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta charset="UTF-8" />
    </Helmet>
  )
}

export default Meta;